import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-numeric-text-box',
  templateUrl: './numeric-text-box.component.html',
  styleUrls: ['./numeric-text-box.component.scss']
})
export class NumericTextBoxComponent implements OnInit {

  @Input() public numericData: number;
  @Input() public maxQty: number;
  @Input() public isUpdateButton: boolean = false;
  @Output() public event: EventEmitter<number> = new EventEmitter();
  /*@Output() public numericMinusEvent = new EventEmitter();*/
  currentValue: number;
  visibleUpdateButton: boolean = false;
  constructor() { }

  ngOnInit() {
    this.currentValue = this.numericData;
  }

  handleMinus(numericData: any) {
    if (this.numericData > 1) {
      this.numericData = this.numericData - 1;
      this.setUpdateButtonVisibility();
      //this.event.emit(this.numericData);
    }
  }

  handlePlus(numericData:any) {
    if (this.numericData < this.maxQty) {
      this.numericData = this.numericData + 1;
      this.setUpdateButtonVisibility();
      //this.event.emit(this.numericData);
    }
  }

  setValue() {
    if (!this.isUpdateButton) {
      this.event.emit(this.numericData);
    }
    this.setUpdateButtonVisibility();
  }
  setValueOnUpdateClick() {
    this.currentValue = this.numericData;
    this.visibleUpdateButton = false;
    this.event.emit(this.numericData);
  }
  setUpdateButtonVisibility() {
    if (this.currentValue == this.numericData) {
      this.visibleUpdateButton = false;
    }
    else {
      this.visibleUpdateButton = true;
    }
  }
}
